export default __webpack_public_path__ + "static/media/video-cta.20bfc59a.jpg";